import Divide from './divide';

export default Divide;
